import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import Urls from '@constants';

const VUEXNS = 'monitorhub';

function hubClient(token) {
	return new HubConnectionBuilder()
		.configureLogging(LogLevel.Debug) // poner en configuracion
		.withAutomaticReconnect()
		.withUrl(Urls.MONITOR_HUB, { accessTokenFactory: () => token })

		.build();
}

function setUpSignalRClientHandlers(client, store) {
	client.on('stateChanged', (oldState, newState) => {
		console.error('Socket ' + oldState + ' ' + newState);
		if (oldState !== newState && newState !== 'Connected')
			store.dispatch(`${VUEXNS}/connectionClosed`);
		else store.dispatch(`${VUEXNS}/connectionOpened`);
	});

	client.on('ReceiveMessage', (message) => {
		store.dispatch(`${VUEXNS}/addMessage`, message);
	});

	client.on('HB', (folio, ts) => {
		store.dispatch(`${VUEXNS}/AspiranteHB`, { folio, ts });
	});
	client.on('NuevoVideo', (folio, url, tipo) => {
		store.dispatch(`${VUEXNS}/NuevoVideo`, { folio, url, tipo });
	});

	client.on('Desconectar', (folio) => {
		store.dispatch(`${VUEXNS}/Desconectar`, { folio });
	});
	client.on('SaltoPregunta', (folio, totalSaltadas) => {
		store.dispatch(`${VUEXNS}/saltoPregunta`, { folio, totalSaltadas });
	});

	client.on('EstadoExamen', (folio, totalPreguntas, finalizoExamen) => {
		store.dispatch(`${VUEXNS}/EstadoExamen`, {
			folio,
			totalPreguntas,
			finalizoExamen
		});
	});

	client.on('PreguntaActual', (folio, preguntaActual) => {
		console.log(
			'llego una pregunta para ',
			folio,
			'con la',
			' actual ->',
			preguntaActual
		);
		store.dispatch(`${VUEXNS}/PreguntaActual`, { folio, preguntaActual });
	});
	client.on('Avance', (folio, avance) => {
		store.dispatch(`${VUEXNS}/Avance`, { folio, avance });
	});

	client.on(
		'EstadoAspirante',
		(
			ficha,
			numeroMensajes,
			ultimoMensajeTS,
			preguntaActual,
			totalPreguntas,
			finalizoExamen,
			listaSaltadas,
			listaAvance,
			listaCamara,
			listaPantalla,
			listaMensajes
		) => {
			store.dispatch(`${VUEXNS}/EstadoAspirante`, {
				ficha,
				numeroMensajes,
				listaMensajes,
				preguntaActual,
				totalPreguntas,
				finalizoExamen
			});
		}
	);
}

export default function createWebSocketPlugin(SR) {
	return (store) => {
		store.subscribe((mutation, state) => {
			if (mutation.type.startsWith(`${VUEXNS}/`)) {
				if (state.monitorhub.connectado) {
					switch (mutation.type) {
						case `${VUEXNS}/INICIAR`:
							SR.client.send('Iniciar');
							break;
						case `${VUEXNS}/HB`:
							SR.client.send('HB', '' + Date.now()).catch((err) => {
								console.error(err);
							});
							break;
						case `${VUEXNS}/ENVIARMENSAJE`:
							SR.client.send(
								'Mensaje',
								mutation.payload.folio,
								mutation.payload.mensaje
							);
							break;
						case `${VUEXNS}/BLOQUEARASPIRANTE`:
							SR.client.send(
								'Bloquear',
								mutation.payload.folio,
								mutation.payload.mensaje
							);
							break;
					}
				} else if (mutation.type === `${VUEXNS}/OPEN_CONNECTION`) {
					SR.client = hubClient(state.oidc.access_token);
					setUpSignalRClientHandlers(SR.client, store);
					SR.client
						.start()
						.then(() => {
							store.dispatch(`${VUEXNS}/connectionOpened`);
							setInterval(function() {
								store.dispatch(`${VUEXNS}/HearthBeat`);
							}, 5000);
						})
						.catch((err) => {
							store.dispatch(`${VUEXNS}/connectionError`, err);
						});
				}
			}
		});
	};
}
